import type { UnknownObject } from '~/shared/interfaces'
import type { YandexMetricOptions as YandexMetricOptionsAbstract } from '~/shared/interfaces/yandex-metrics'
import { isString, isNumber, isBoolean, isUnknownObject } from '~/shared/utils/guards'

export class YandexMetricOptions {
  protected readonly rawData: UnknownObject = {}

  constructor(data?: unknown) {
    if (isUnknownObject(data)) {
      this.rawData = data
    }
  }

  get options(): YandexMetricOptionsAbstract {
    return {
      id: isString(this.rawData.id) ? this.rawData.id : '',
      accurateTrackBounce: isBoolean(this.rawData.accurateTrackBounce) ? this.rawData.accurateTrackBounce : undefined,
      clickmap: isBoolean(this.rawData.clickmap) ? this.rawData.clickmap : undefined,
      defer: isBoolean(this.rawData.defer) ? this.rawData.defer : undefined,
      ecommerce: isBoolean(this.rawData.ecommerce) ? this.rawData.ecommerce : undefined,
      trackHash: isBoolean(this.rawData.trackHash) ? this.rawData.trackHash : undefined,
      trackLinks: isBoolean(this.rawData.trackLinks) ? this.rawData.trackLinks : undefined,
      webvisor: isBoolean(this.rawData.webvisor) ? this.rawData.webvisor : undefined,
      triggerEvent: isBoolean(this.rawData.triggerEvent) ? this.rawData.triggerEvent : undefined,
      type: isNumber(this.rawData.type) ? this.rawData.type : undefined,
      params: Array.isArray(this.rawData.params) && this.rawData.params.length > 0 ? this.rawData.params : undefined,
      userParams: isUnknownObject(this.rawData.userParams) ? this.rawData.userParams : undefined,
    }
  }
}
